var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 2.99998H6.8C5.11984 2.99998 4.27976 2.99998 3.63803 3.32696C3.07354 3.61458 2.6146 4.07353 2.32698 4.63801C2 5.27975 2 6.11983 2 7.79998V16.2C2 17.8801 2 18.7202 2.32698 19.362C2.6146 19.9264 3.07354 20.3854 3.63803 20.673C4.27976 21 5.11984 21 6.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9264 19.673 19.362C20 18.7202 20 17.8801 20 16.2V12M7.99997 15H9.67452C10.1637 15 10.4083 15 10.6385 14.9447C10.8425 14.8957 11.0376 14.8149 11.2166 14.7053C11.4184 14.5816 11.5914 14.4086 11.9373 14.0627L21.5 4.49998C22.3284 3.67156 22.3284 2.32841 21.5 1.49998C20.6716 0.671556 19.3284 0.671555 18.5 1.49998L8.93723 11.0627C8.59133 11.4086 8.41838 11.5816 8.29469 11.7834C8.18504 11.9624 8.10423 12.1574 8.05523 12.3615C7.99997 12.5917 7.99997 12.8363 7.99997 13.3255V15Z",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.acfb8150c49991a2d6cbbf68bd726dc8.svg";
export { ForwardRef as ReactComponent };